import {animateInViewport} from "./transition";
import matchHeight from 'jquery-match-height';

let jQueryBridget = require( 'jquery-bridget' );
let Masonry = require( 'masonry-layout' );

jQueryBridget( 'masonry', Masonry, $ );

$( function() {
	$( '.match-height' ).matchHeight();

	window.msnry = $( '.masonry' )
		.on( 'layoutComplete', function() {
			animateInViewport();
		} )
		.masonry( {
			itemSelector: '.masonry-item',
			gutter: 24,
			columnWidth: '.masonry-item:not(.hidden):not(.filtered)',
			transitionDuration: 0,
		} );
} );
